import React from 'react';
import Slider from 'react-slick';

const TestimonialSection = () => {
  const testimonials = [
    {
      text: 'The service was fantastic! The driver was punctual, friendly and made our journey comfortable. I highly recommend SHREE Tours & Travels for anyone traveling in and around the city.',
      image: 'images/resource/testi3-1.png',
      name: 'Mr. Rajesh Kumar',
      designation: 'Customer',
    },
    {
      text: 'I had a wonderful experience with SHREE Tours & Travels. The vehicle was clean, well-maintained and the driver was very polite. I will definitely book again for my future travels.',
      image: 'images/resource/testi3-2.png',
      name: 'Miss. Priya Deshmukh',
      designation: 'Customer',
    },
    {
      text: 'SHREE Tours & Travels made our family trip to Mumbai so much more enjoyable. The car was spacious and the driver was professional and courteous. Great experience overall!',
      image: 'images/resource/testi3-3.png',
      name: 'Mr. Anil Sharma',
      designation: 'Customer',
    },
    {
      text: 'We booked a taxi from Pune to Shirdi through SHREE Tours & Travels and it was a smooth and comfortable journey. The driver was knowledgeable and took us through the best routes.',
      image: 'images/resource/testi3-1.png',
      name: 'Miss. Aarti Patil',
      designation: 'Customer',
    },
    {
      text: 'Thank you for the excellent service! The car was well-maintained and the driver was extremely professional. It was a hassle-free experience and I will surely recommend it to my friends and family.',
      image: 'images/resource/testi3-2.png',
      name: 'Mr. Vijay Rao',
      designation: 'Customer',
    },
    {
      text: 'The best taxi service I’ve ever used! The ride was comfortable and the driver was on time and courteous. I’m happy to have found SHREE Tours & Travels for all my travel needs.',
      image: 'images/resource/testi3-3.png',
      name: 'Miss. Sneha Gupta',
      designation: 'Customer',
    },
  ];
  

  // Slider settings for showing 3 slides at a time on larger screens
  const settings = {
    infinite: true,  // Infinite loop
    autoplay: true,  // Enable auto-slide
    autoplaySpeed: 3000,  // Auto-slide speed (3 seconds)
    dots: true,  // Show navigation dots
    arrows: false,  // Disable arrows
    speed: 500,  // Transition speed
    slidesToShow: 3,  // Show 3 slides at a time on larger screens
    slidesToScroll: 1,  // Scroll 1 slide at a time
    responsive: [
      {
        breakpoint: 1024,  // For screens smaller than 1024px
        settings: {
          slidesToShow: 3,  // Show 3 slides at a time
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,  // For screens smaller than 768px
        settings: {
          slidesToShow: 1,  // Show 1 slide at a time on mobile
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <section className="testimonial-section-four">
      <div className="bg bg-image"></div>
      <div className="container pt-0 pb-0">
        <div className="sec-title text-center">
          {/* <span className="sub-title line-style">Our Customer Say</span> */}
          <h2 className="letters-slide-up " style={{fontFamily:'Segoe Script'}}>Customer Feedback and Insights</h2>
          <i className="sub-title " style={{fontFamily:'Times New Roman'}}>Customer satisfaction is our top priority. Here’s what our customers are saying about us !</i>
          {/* <h2 className="letters-slide-up text-split"></h2> */}
        </div>
        <div className="outer-box">
          {/* React Slick Slider */}
          <Slider {...settings} className="testimonial-carousel-two">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="testimonial-block-four">
                <div className="inner-box">
                  <div className="content">
                    <div className="text">{testimonial.text}</div>
                    <div className="box-info">
                      <div className="author-box">
                        <figure className="author-image">
                          {/* <img src={testimonial.image} alt="" /> */}
                        </figure>
                        <div className="author-info">
                          <h6 className="name">{testimonial.name}</h6>
                          <span className="designation">{testimonial.designation}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;
